import { Injectable } from '@angular/core';
import { AssetInScene } from '../models/AssetInScene';
import { ModalController } from '@ionic/angular';
import { ApiQuestionRuleService } from '../api-services/question-rule.api.service';
import { QuestionRuleTypeService } from './question-rule-type.service';
import { QuestionRule } from '../models/question-rules/QuestionRule';

@Injectable({
  providedIn: 'root'
})
export class QuestionRuleService {

  constructor(
    public QuestionRuleAPIService: ApiQuestionRuleService,
    public questionRuleTypeService: QuestionRuleTypeService,
    public modalController: ModalController) { }

  removeQuestionRule(assetInScene: AssetInScene, index: number){
    assetInScene.questionRules[index].toBeRemoved = true;
  }

  isQuestionRuleType(questionRuleTypeId: number): boolean{
    if((this.getQuestionRuleType(questionRuleTypeId) == 'Display')){
      return true;
    }else{
      return false;
    }
  }

  getNewQuestionRule(): QuestionRule{
    var questionRule: QuestionRule = {
      'questionRuleId': 0,
      'questionRuleTypeId': this.getQuestionRuleTypeId('Display'),
      'sceneAssetRelationId': -1,
      'questionResponseIndex': -1,
      'linkedSceneAssetRelationId': -1,
      'linkedQuestionIndex': -1,
      'toBeRemoved' : false
    }

    return questionRule;
  }

  // This adds an event to the database and pushes to event to the assetInScene.events when the user selects 'Add Event' button.
  addQuestionRule(assetInScene: AssetInScene): QuestionRule{
    var questionRule: QuestionRule = this.getNewQuestionRule();
    
    questionRule.sceneAssetRelationId = assetInScene.sceneAssetRelation.sceneAssetRelationId;
    
    return questionRule;
  }

  getQuestionRuleTypes(){
    return this.questionRuleTypeService.types;
  }

  getQuestionRuleType(questionRuleTypeId: number){
    return this.questionRuleTypeService.getType(questionRuleTypeId);
  }

  getQuestionRuleTypeId(type: string){
    return this.questionRuleTypeService.getId(type);
  }
  
  // author.service.ts handles the OnDidDismiss()
  saveChanges(){
    this.modalController.dismiss();
  }

}
